<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader>
          <v-row dense>
            <v-col cols="12" sm="11">
              <div class="mt-2">
                Status da requisicao (ERP)
              </div>
            </v-col>
            <v-col cols="12" sm="1">
              <div class="d-flex icon justify-end">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="onClickRefresh" :disabled="loading">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Atualizar</span>
                </v-tooltip>
                <v-tooltip top v-if="showLogs">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="onClickHideLog">
                      <v-icon>{{ icon }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ hideLogText }}</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
        </v-subheader>
        <v-divider/>
        <px-lista-logs v-if="showLogs && !hideLog"
          :logs="logs"
          :loading="loading"
          :on-change-options="onChangeOptions"
          :options-list="optionsList"
          @update="onClickRefresh"/>
        <v-card-text v-else>
          {{ emptyLogsText }}
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import IntegracaoService from '@/api/integracao-service';
import paginationMixin from '@/mixins/pagination-mixin';

export default {
  mixins: [paginationMixin],
  props: {
    idRequisicao: Number,
  },
  data() {
    return {
      logs: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 5,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      optionsList: {},
      hideLog: false,
      loading: false,
    };
  },
  computed: {
    icon() {
      return this.hideLog ? 'mdi-eye-closed' : 'mdi-eye';
    },
    showLogs() {
      return this.logs.content && this.logs.content.length;
    },
    emptyLogsText() {
      return this.hideLog ? 'Logs ocultados' : 'Nenhum log para esse registro';
    },
    hideLogText() {
      return this.hideLog ? 'Exibir logs' : 'Ocultar logs';
    },
  },
  methods: {
    onClickHideLog() {
      this.hideLog = !this.hideLog;
    },
    onClickRefresh() {
      this.getLogs();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onChangeFilter() {
      this.resetPage();
      this.getLogs();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getLogs();
    },
    getLogs() {
      this.loading = true;
      const params = {
        limit: this.listOptions.limit,
        offset: this.listOptions.offset,
        query: this.buildQuery(this.listOptions),
      };
      IntegracaoService.getLogsRequisicao(this.idRequisicao, params)
        .then((response) => {
          this.logs = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.getLogs();
  },
};
</script>
